const { __, _x, _n, _nx } = wp.i18n;

/**
 * Implements the point out error link and popup for comments.
 */
var PointOutError = ( function() {
	var C = function(){ return constructor.apply(this,arguments); };
	var p = C.prototype;

	p.comment = null;

	function constructor( comment ) {
		var self = this;
		this.comment = comment;
		this.commentID = comment.id.match( /^comment-(\d+)$/ )[1];
		this.link = this.comment.querySelector( '.comment-point-out-error' );
		if ( this.link ) {
			this.link.addEventListener(
				'click', function( event ) {
					event.preventDefault();
					self.open();
				} );
		}
		this.clearLink = this.comment.querySelector( '.comment-clear-errors' );
		if ( this.clearLink ) {
			this.clearLink.addEventListener(
				'click', function( event ) {
					event.preventDefault();
					self.open( true );
				} );
		}
	};

	// Creates and opens the report popup.
	p.open = function( clear ) {
		var message = __( 'Are you sure to report false information for this comment?' , 'iportal-core' );
		if ( clear ) {
			message = __( 'Are you sure to clear error reports for this comment?' , 'iportal-core' );
		}
		var $popup = jQuery( `
<div class="modal" tabindex="-1" role="dialog" aria-hidden="true">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<div class="modal-body">
				<p class="alert alert-danger">
					<i class="fa fa-exclamation-triangle"></i>
					${message}
				</p>
			</div>
			<div class="modal-footer">
				<form method="POST">
					<button type="submit" class="btn btn-danger">${__( 'Yes', 'iportal-core' )}</button>
				</form>
				<button type="button" class="btn btn-secondary" data-dismiss="modal">
					${__( 'Cancel', 'iportal-core' )}
				</button>
			</div>
		</div>
	</div>
</div>
`);
		var self = this;
		this.submitButton = $popup.find( 'button[type="submit"]' ).get( 0 );
		$popup.on( 'hidden.bs.modal', function( e ) { jQuery( this ).remove(); } );
		$popup.find( 'form' ).on( 'submit', function( event ) {
			event.preventDefault();
			self.submitButton.setAttribute( 'disabled', true );
			self.submitButton.innerHTML = `<i class='fa fa-circle-o-notch fa-spin'></i>`;
			self.pointOutError( $popup, clear );
		} );
		$popup.modal();
	};

	// Retreives and inserts news content into popup.
	p.pointOutError = function( $popup, clear ) {
		var self = this;
		var jqxhr = jQuery.ajax( {
			method: clear ? 'DELETE' : 'PUT',
			url: wpApiSettings.root + 'iportal/v1/comment_error/' + this.commentID,
			beforeSend: function( xhr ) {
				xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
			},
		} ).done( function( response ) {
			$popup.modal( 'hide' );
			jQuery( self.link ).replaceWith( `<span><i class='fa fa-check'></i></span>` );
		} ).fail( function() {
			$popup.find( '.modal-body').html(
				`<div class="alert alert-danger">
					${__( 'There was an error, please try again later.', 'iportal-core' )}
				</div>` );
			self.submitButton.remove();
		} );
	};

	return C;
} )();

export default PointOutError;
